import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrders,
  getOrdersByDateTimeRange,
  getSaleByDateTimeRangeOrUsername,
  RESETORDER,
  selectOrderByCashier,
  selectOrderByDate,
  selectOrders,
} from "../../redux/features/order/OrderSlice";
import dayjs from "dayjs";
import { GiMoneyStack } from "react-icons/gi";
import {
  filterReceipts,
  selectFilteredReceipts,
} from "../../redux/features/filter/FilterSlice";
import { FaDownload, FaPaperPlane } from "react-icons/fa";
import { toast } from "react-toastify";
// import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import logo from "../../Asset/logo.png";

const Receipt = () => {
  const dispatch = useDispatch();
  const orders = useSelector(selectOrders);
  const [groupedOrders, setGroupedOrders] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [visibleDates, setVisibleDates] = useState({});
  const [search, setSearch] = useState("");
  const filterReceipt = useSelector(selectFilteredReceipts);
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const managerName = process.env.REACT_APP_MANAGER_NAME;
  const companyAddress = process.env.REACT_APP_COMPANY_ADDRESS;
  const companyPhone = process.env.REACT_APP_COMPANY_PHONE;
  const companyEmail = process.env.REACT_APP_COMPANY_EMAIL;
  const companyWebsite = process.env.REACT_APP_COMPANY_WEBSITE;
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setDates((prevDates) => ({
      ...prevDates,
      [name]: value,
    }));
  };

  const orderByDate = useSelector(selectOrderByDate);
  const orderByCashier = useSelector(selectOrderByCashier);
  // console.log(orderByDate);
  const [cardOrders, setCardOrders] = useState([]);
  const [cashOrders, setCashOrders] = useState([]);
  const [onlineOrders, setOnlineOrders] = useState([]);

  const filterOrdersByPayment = (orders, amountType) => {
    return orders.filter(
      (order) => order.amountType.toLowerCase() === amountType
    );
  };

  useEffect(() => {
    setCardOrders(filterOrdersByPayment(orderByDate, "card"));
    setCashOrders(filterOrdersByPayment(orderByDate, "cash"));
    setOnlineOrders(filterOrdersByPayment(orderByDate, "online"));
  }, [orderByDate]);

  const handleClick = async () => {
    if (!dates.startDate || !dates.endDate) {
      toast.error("Start and End Date both are requried");
      return;
    }
    const orderData = {
      startDate: dates.startDate,
      endDate: dates.endDate,
    };
    await dispatch(getOrdersByDateTimeRange(orderData));
    await dispatch(getSaleByDateTimeRangeOrUsername(orderData));
  };

  const toggleDateVisibility = (date) => {
    setVisibleDates((prev) => ({
      ...prev,
      [date]: !prev[date],
    }));
  };

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  // set the date format and last 30 days receipt
  useEffect(() => {
    if (filterReceipt && filterReceipt.length > 0) {
      const now = dayjs();
      const filteredOrders = filterReceipt.filter((order) =>
        dayjs(order.createdAt).isAfter(now.subtract(30, "days"))
      );

      const grouped = filteredOrders.reduce((acc, order) => {
        const orderDate = dayjs(order.createdAt).format("D MMMM YYYY (dddd)");
        if (!acc[orderDate]) {
          acc[orderDate] = [];
        }
        acc[orderDate].push(order);
        return acc;
      }, {});

      setGroupedOrders(grouped);
    }
  }, [filterReceipt]);

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    dispatch(RESETORDER());
    setDates({
      startDate: "",
      endDate: "",
    });
  };

  useEffect(() => {
    dispatch(filterReceipts({ search, orders }));
  }, [dispatch, search, orders, dates]);

  const componentPDF = useRef();
  const generatePDF = () => {
    const element = componentPDF.current;
    const options = {
      margin: 0.5,
      filename: `Orders Summary ${dayjs(dates.startDate).format(
        "YYYY-MM-DD hh:mm A"
      )} to ${dayjs(dates.endDate).format("YYYY-MM-DD hh:mm A")}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };

  const totalAmount = orderByDate
    .reduce((sum, order) => {
      const amountToAdd =
        order.totalAmountAfterDiscount > 0
          ? order.totalAmountAfterDiscount
          : order.totalAmount;
      return sum + amountToAdd;
    }, 0)
    .toFixed(2);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      <div>
        <Navbar page="Receipts" />
      </div>
      <div className="flex h-full overflow-hidden">
        <div className="lg:w-[30%] md:w-[39%] md:block hidden overflow-y-auto scrollbar-hide bg-white shadow-md">
          {/* <OrderList /> */}
          <div className="w-full">
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="outline-none p-4 w-full"
              placeholder="Search by order no"
            />
          </div>
          <div>
            {Object.entries(groupedOrders).map(([date, orders]) => (
              <div key={date}>
                <div
                  onClick={() => toggleDateVisibility(date)}
                  className={`px-6 lg:px-8 bg-[#7D7D7D] text-white py-3 text-[11px] lg:text-[13px] font-bold cursor-pointer ${
                    visibleDates[date] ? "" : "border-b border-white"
                  }`}
                >
                  {date}
                </div>
                <div
                  className={`overflow-hidden transition-max-height transition-transform duration-1000 delay-500 ease-in-out  ${
                    visibleDates[date] ? "max-h-max" : "max-h-0"
                  }`}
                >
                  {orders.map((order) => (
                    <div
                      key={order._id}
                      onClick={() => handleOrderClick(order)}
                      className={`border-b px-6 lg:px-8 py-2 flex items-center cursor-pointer ${
                        selectedOrder && selectedOrder._id === order._id
                          ? "bg-[#0D868C] "
                          : ""
                      }`}
                    >
                      <GiMoneyStack
                        className={`size-8 mr-3  ${
                          selectedOrder && selectedOrder._id === order._id
                            ? "text-white "
                            : "text-[#0D868C]"
                        }`}
                      />{" "}
                      <div className="order-info">
                        <div
                          className={`lg:text-[1rem] text-[.8rem] font-semibold ${
                            selectedOrder && selectedOrder._id === order._id
                              ? "text-white "
                              : "text-[#1E1E1E]"
                          }`}
                        >
                          €
                          {order.totalAmountDiscount > 0
                            ? order.totalAmountAfterDiscount.toFixed(2)
                            : order.totalAmount.toFixed(2)}
                        </div>
                        <div
                          className={`lg:text-[.75rem] text-[.6rem] font-semibold ${
                            selectedOrder && selectedOrder._id === order._id
                              ? "text-[white] "
                              : "text-[#A9A9A9]"
                          }`}
                        >
                          {dayjs(order.createdAt).format("h:mm A")}
                        </div>
                      </div>
                      <div
                        className={`ml-auto text-[.75rem] ${
                          selectedOrder && selectedOrder._id === order._id
                            ? "text-[white] "
                            : "text-[#A9A9A9]"
                        }`}
                      >
                        #{order.orderNo}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* card */}
        <div className="flex-1 lg:p-8 py-6 overflow-y-auto scrollbar-hide relative flex flex-col justify-between">
          {orderByDate?.length > 0 ? (
            <div className="flex flex-col justify-between gap-3 px-10">
              <div className="flex justify-end">
                <button
                  onClick={generatePDF}
                  className="flex justify-center w-max items-center text-[white] bg-[#0D868C] rounded-lg p-2 font-semibold gap-2"
                >
                  {" "}
                  <FaDownload />
                  DownLoad
                </button>
              </div>

              <div
                ref={componentPDF}
                style={{ width: "100%" }}
                className=" lg:py-6 py-4 px-4 w-[80%] mx-auto bg-white shadow-md
                rounded-xl flex flex-col gap-4"
              >
                <div className="text-[#888787] flex flex-col">
                  <div className="flex justify-between">
                    {companyName && (
                      <p className="text-2xl text-[#575656] font-extrabold">
                        {companyName}
                      </p>
                    )}
                    <img src={logo} className="w-14 ml-auto" alt="" />
                  </div>
                  {companyEmail && (
                    <p>
                      Email:{" "}
                      <a href={`mailto:${companyEmail}`}>{companyEmail}</a>
                    </p>
                  )}
                  {companyWebsite && (
                    <p>
                      Website:{" "}
                      <a
                        href={companyWebsite}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {companyWebsite}
                      </a>
                    </p>
                  )}
                  {companyAddress && <p>Address: {companyAddress}</p>}
                  {companyPhone && <p>Phone: {companyPhone}</p>}
                  {managerName && <p>Manager: {managerName}</p>}
                  {totalAmount && (
                    <p>
                      Total Sale : {priceSymbol} {totalAmount}{" "}
                    </p>
                  )}
                  <p>
                    Start Date:{" "}
                    {dayjs(dates.startDate).format("YYYY-MM-DD hh:mm A")}
                  </p>
                  <p>
                    End Date:{" "}
                    {dayjs(dates.endDate).format("YYYY-MM-DD hh:mm A")}
                  </p>
                </div>
                {/* report table */}
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left">
                        Order Type
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left">
                        Total Orders
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left">
                        Total Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">
                        Total Order
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {orderByDate.length}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {orderByDate
                          .reduce((sum, order) => {
                            const amountToAdd =
                              order.totalAmountAfterDiscount > 0
                                ? order.totalAmountAfterDiscount
                                : order.totalAmount;
                            return sum + amountToAdd;
                          }, 0)
                          .toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" className="text-center  py-2">
                        Amount Collected by Payment Method
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Cash</td>
                      <td className="border border-gray-300 px-4 py-2">
                        {cashOrders.length}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {cashOrders
                          .reduce((sum, order) => {
                            const amountToAdd =
                              order.totalAmountAfterDiscount > 0
                                ? order.totalAmountAfterDiscount
                                : order.totalAmount;
                            return sum + amountToAdd;
                          }, 0)
                          .toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Card</td>
                      <td className="border border-gray-300 px-4 py-2">
                        {cardOrders.length}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {cardOrders
                          .reduce((sum, order) => {
                            const amountToAdd =
                              order.totalAmountAfterDiscount > 0
                                ? order.totalAmountAfterDiscount
                                : order.totalAmount;
                            return sum + amountToAdd;
                          }, 0)
                          .toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">
                        Online
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {onlineOrders.length}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {onlineOrders
                          .reduce((sum, order) => {
                            const amountToAdd =
                              order.totalAmountAfterDiscount > 0
                                ? order.totalAmountAfterDiscount
                                : order.totalAmount;
                            return sum + amountToAdd;
                          }, 0)
                          .toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" className="text-center  py-2">
                        Sale by Cashier{" "}
                      </td>
                    </tr>
                    {orderByCashier?.map((cashier, i) => (
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 capitalize">
                          {cashier.name}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {cashier.orderCount}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {cashier.totalSale.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : selectedOrder ? (
            <div>
              <div className="flex justify-center items-center">
                <div className="lg:py-6 py-4 px-4 w-[70%] lg:w-[50%] mx-auto bg-white shadow-md rounded-xl flex flex-col gap-4">
                  {/* Top Section */}
                  <div className="w-full text-center">
                    <h1 className="lg:text-[2.75rem] text-[2rem] font-bold text-[#1E1E1E]">
                      {priceSymbol}{" "}
                      {selectedOrder.totalAmountDiscount > 0
                        ? selectedOrder.totalAmountAfterDiscount.toFixed(2)
                        : selectedOrder.totalAmount.toFixed(2)}
                    </h1>
                    <h2 className="text-[#0D868C] lg:text-[1rem] text-[.8rem] font-bold capitalize">
                      Total paid
                    </h2>
                  </div>

                  {/* Lower Top Section */}
                  <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
                    <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal">
                      Employee:{" "}
                      <span className="capitalize">
                        {selectedOrder.cashierName}
                      </span>
                    </p>
                  </div>
                  {/* Middle Section */}
                  <div>
                    {selectedOrder.products.map((item, index) => (
                      <div
                        key={item._id}
                        className={`flex items-center w-full lg:gap-6 gap-4 p-2 ${
                          index !== 0 ? "border-t border-[#DEDEDE]" : ""
                        }`}
                      >
                        <div className="flex flex-col flex-1">
                          <h2 className="text-[#0D868C] text-[.8rem] text-wrap lg:text-[.9rem] font-medium capitalize">
                            {item.name}
                          </h2>
                        </div>
                        <div className="flex items-center justify-between w-[35%] text-[#A9A9A9] text-[.6rem] lg:text-[.9rem]">
                          <p className="w-[50%]">X{item.quantity}</p>
                          <p className="text-left w-[50%]">
                            {priceSymbol}{" "}
                            {(Number(item.price) * item.quantity).toFixed(0)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* Upper Lower Section */}
                  <div>
                    <p className="flex flex-col justify-between items-center lg:p-4 p-3 lg:text-[1rem] text-[.8rem] border-y-2 border-[#DEDEDE]">
                      {selectedOrder.totalAmountDiscount > 0 ? (
                        <div className="flex justify-between items-center w-full">
                          <span className="text-[#0D868C] font-bold">
                            Total
                          </span>
                          <span className="text-[#868585] flex gap-3 items-center ">
                            <span className=" line-through text-[#c2c0c0]">
                              {priceSymbol}
                              {selectedOrder.totalAmount.toFixed(2)}
                            </span>
                            {priceSymbol}
                            {selectedOrder.totalAmountAfterDiscount.toFixed(2)}
                          </span>
                        </div>
                      ) : (
                        <div className="flex justify-between items-center w-full">
                          <span className="text-[#0D868C] font-bold">
                            Total
                          </span>
                          <span className="text-[#868585]">
                            {priceSymbol}
                            {selectedOrder.totalAmount.toFixed(2)}
                          </span>
                        </div>
                      )}
                      {selectedOrder.paidAmount > 0 && (
                        <div className="flex flex-col w-full text-[.8rem]">
                          <div className="flex justify-between items-center w-full">
                            <span className="text-[#0D868C] font-bold capitalize">
                              {selectedOrder.amountType}
                            </span>
                            <span className="text-[#868585]">
                              {priceSymbol}
                              {selectedOrder.paidAmount.toFixed(2)}
                            </span>
                          </div>
                          {selectedOrder.totalAmountDiscount > 0 ? (
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#0D868C] font-bold">
                                Paid
                              </span>
                              <span className="text-[#868585] flex gap-3 items-center ">
                                {priceSymbol}
                                {selectedOrder.totalAmountAfterDiscount.toFixed(
                                  2
                                )}
                              </span>
                            </div>
                          ) : (
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#0D868C] font-bold">
                                Paid
                              </span>
                              <span className="text-[#868585]">
                                {priceSymbol}
                                {selectedOrder.totalAmount.toFixed(2)}
                              </span>
                            </div>
                          )}
                          {selectedOrder.amountType.toLowerCase() ===
                            "cash" && (
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#0D868C] font-bold">
                                Change
                              </span>
                              <span className="text-[#868585]">
                                {priceSymbol}
                                {selectedOrder.returnAmount.toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </p>
                  </div>
                  {/* Lower Section */}
                  <div className="flex justify-between items-center text-[#A9A9A9] lg:text-[12px] text-[10px] lg:px-4 px-3 py-2">
                    <p>
                      {dayjs(selectedOrder.createdAt).format(
                        "D /M /YYYY . h:mm A"
                      )}
                    </p>
                    <p>#{selectedOrder.orderNo}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <p className="text-[#A9A9A9] pl-4">
                Click on an order to view details.
              </p>
            </div>
          )}

          {/* Date Input Container */}
          <div className="lg:w-[80%] w-full mx-auto sticky bottom-0 left-0 px-4 flex justify-center mt-8">
            <div className="bg-white/10 backdrop-blur px-4 py-2 pb-[.9rem] w-full  rounded-full shadow-md flex gap-2 items-end ">
              <div className="w-full flex flex-col justify-center">
                <label
                  htmlFor=""
                  className="text-[12px] pl-4 capitalize text-[#0D868C]"
                >
                  start date
                </label>

                <input
                  type="datetime-local"
                  name="startDate"
                  value={dates.startDate}
                  onChange={handleDateChange}
                  className="w-full  p-2 bg-white/10 backdrop-blur-0 lg:text-[12px] text-[10px] text-[#0D868C] border rounded-full outline-none "
                />
              </div>
              <div className="w-full flex flex-col justify-center">
                <label
                  htmlFor=""
                  className="text-[12px] pl-4 capitalize text-[#0D868C]"
                >
                  end date
                </label>
                <input
                  type="datetime-local"
                  name="endDate"
                  value={dates.endDate}
                  onChange={handleDateChange}
                  className="w-full p-2 bg-white/10 backdrop-blur-0 lg:text-[12px] text-[10px] text-[#0D868C] border rounded-full outline-none "
                />
              </div>
              <button
                onClick={handleClick}
                className="bg-[#0D868C]  rounded-full lg:p-3 p-[10px] text-white"
              >
                <FaPaperPlane className="lg:size-6 size-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
